import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import { Box, Card, Checkbox, Grid, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import isEmpty from 'lodash-es/isEmpty';
import { useMemo, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { BiShareAlt } from 'react-icons/bi';
import { FiMail } from 'react-icons/fi';
import { MdOutlinePhone } from 'react-icons/md';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { markEmailAsPrimary, amplitude } from 'wisestep-api';
import {
  WsColors,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  WsIconText,
  WsTagsList,
  ChipsType,
  WsButton,
  timeSince,
  WsIconTag,
  WsDialog,
  getDateUsingFormat,
  highlightKeys,
  WsChip,
  WsChipVariants,
  WsDrawer,
  WsBadge,
  WsBadgeSize,
  WsBadgetype,
} from 'wisestep-base';

import { useWorkspaceContext } from '../../../../../../src/context';
import { accessDeniedNotoficationTxt } from '../../../../../components/AccessControl/AccessControl';
import CandidateStageStatus from '../../../../../components/candidateStageStatus';
import CommunicationLinks from '../../../../../components/CommunicationLinks/CommunicationLinks';
import PulseIconText from '../../../../../components/PulseIconText';
import CircularImage from '../../../../../components/WsCustomImage/CircularImage';
import { WsTaskCreationCard } from '../../../../../components/WsTaskCreationCard';
import JobSelection from '../../../../../features/conversationWidget/components/JobSelection';
import UpdateProfileNew from '../../../../../features/conversationWidget/components/UpdateProfileNew';
import { CandidateAtsAccess, useCandidateAts } from '../../../../../hooks/useCandidateAts';
import ErrorLogger from '../../../../../providers/ErrorLogger';
import { getDncMessage } from '../../../../../utils/DncMessage';
import getEncodedQueryParams from '../../../../../utils/getEncodedQueryParams';
import { warning } from '../../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../../utils/NotificationStore';
import { useConversationWidgetStore } from '../../../../../utils/useConversationWidgetStore';
import MapAsLead from '../../../../conversationWidget/components/MapAsLead';
import conversationWidgetStore from '../../../../conversationWidget/store/conversationWidgetStore';
import ActionWidget from '../../../components/actionWidget/ActionWidget';
import {
  CandidateCardProps,
  CandidateType,
  emailOptions,
  firingAmplitudeEvents,
  getAllAlternateNumbers,
  getCandidateDetails,
  getCandidateScoreStatus,
  phoneOptions,
  removeDuplicates,
  removeDuplicatesPhNos,
  SmallBoxWithRadius,
} from '../../../utils/CandidateHelper';
import useCopyToClipboard from '../../hooks/useCopyToClipboard';

interface OpenWidgetState {
  open: boolean;
  action: 'email' | 'sms' | 'call' | 'mapping' | 'submission' | 'task' | 'rtr';
}
const TalentPoolCandidateCard = ({
  job = null,
  isSelected = false,
  candidate,
  checkBoxOnclick,
  candidateIndex,
  onActionClick,
  queryRefresh,
  interaction,
  amplitudeEventHandler,
  onOpenShareIcon,
  isCvViewed,
  array,
  backwardpathArray = [],
}: CandidateCardProps) => {
  candidate.source = candidate.sources?.[0] ?? candidate.source ?? '';
  candidate.downloadSource = 'TALENTPOOL_SEARCH';
  candidate.isInDnc = candidate.dncDetails?.isInDnc ?? false;
  const selectedJob = conversationWidgetStore((state) => state.selectedJob);
  const updateSelectedJob = conversationWidgetStore((state) => state.updateSelectedJob);
  const workspace = useWorkspaceContext();
  const [openMapping, setOpenMapping] = useState(false);
  const [openSubmitCandidate, setOpenSubmitCandidate] = useState(false);
  const [, copy] = useCopyToClipboard();
  const [open, setOpen] = useState(false);
  const [showMoreContact, setShowMoreContact] = useState(false);
  const [showMoreEmails, setShowMoreEmails] = useState(false);
  const setSelectedEmail = useConversationWidgetStore((state) => state.updateSelectedEmail);

  const navigate = useNavigate();

  const setSelectedPhoneNumber = useConversationWidgetStore(
    (state) => state.updateSelectedPhoneNumber
  );
  const [openJobSelectionWidget, setOpenJobSelectionWidget] = useState<OpenWidgetState>({
    open: false,
    action: 'email',
  });
  const searchQuery = useConversationWidgetStore((state) => state.searchQuery);

  const markEmailAsPrimaryEmail = async (value: string) => {
    const updatedCandidate = await markEmailAsPrimary({
      id: candidate.id ?? '',
      newEmail: value,
    });
    if (updatedCandidate && queryRefresh) {
      queryRefresh();
    }
  };

  const checkboxAmplitudeEvent = () => {
    {
      amplitude(!isSelected ? 'Talentpool_candidate_Select' : 'Talentpool_candidate_UnSelect', {
        clickedOn: 'Checkbox',
        workspaceName: workspace.name,
        pageName: 'Candidates',
        planType: workspace.planType,
        interfaceType: 'web',
        pageUrl: window.location.href,
      });
    }
  };

  const openWidget = (field: string, value: string) => {
    switch (field) {
      case 'Send SMS':
        setSelectedPhoneNumber(value);
        firingAmplitudeEvents('Talentpool_candidate_Send SMS', 'Send SMS', workspace, 'Candidates');
        onActionClick && candidateIndex != undefined && onActionClick(candidateIndex);
        navigate(
          `/candidate-layout/profile?id=${
            candidate.id
          }&array=${array}&action=sms&backwardpathArray=${getEncodedQueryParams(
            JSON.stringify(backwardpathArray)
          )}`
        );
        // setOpenJobSelectionWidget({ open: true, action: 'sms' });
        if (amplitudeEventHandler) amplitudeEventHandler('Send SMS');
        break;
      case 'Call':
        setSelectedPhoneNumber(value);
        onActionClick && candidateIndex != undefined && onActionClick(candidateIndex);
        navigate(
          `/candidate-layout/profile?id=${
            candidate.id
          }&array=${array}&backwardpathArray=${getEncodedQueryParams(
            JSON.stringify(backwardpathArray)
          )}`
        );
        // setOpenJobSelectionWidget({ open: true, action: 'call' });
        //add amplitude here
        break;
      case 'Send Email':
        setSelectedEmail(value);
        firingAmplitudeEvents(
          'Talentpool_candidate_Send Email',
          'Send Email',
          workspace,
          'Candidates'
        );
        onActionClick && candidateIndex != undefined && onActionClick(candidateIndex);
        navigate(
          `/candidate-layout/profile?id=${
            candidate.id
          }&array=${array}&action=email&backwardpathArray=${getEncodedQueryParams(
            JSON.stringify(backwardpathArray)
          )}`
        );
        // setOpenJobSelectionWidget({ open: true, action: 'email' });
        if (amplitudeEventHandler) amplitudeEventHandler('Send Email');
        break;
      case 'Copy':
        copy(value);
        if (amplitudeEventHandler) amplitudeEventHandler('Copy');
        break;
      case 'Mark Primary':
        markEmailAsPrimaryEmail(value);
        if (amplitudeEventHandler) amplitudeEventHandler('Mark Primary');
        break;
    }
  };
  const setNotification = useNotificationStore((state) => state.setNotification);

  const isMapCandidate = useCandidateAts(CandidateAtsAccess.MAP_CANDIDATE);
  const isSubmitCandidate = useCandidateAts(CandidateAtsAccess.SUBMIT_CANDIDATE);
  const recentContactActions =
    candidate.contactActionsObjs?.[candidate.contactActionsObjs.length - 1 ?? 0];
  const actionTags =
    recentContactActions?.actions?.concat(recentContactActions?.result?.result ?? []) ??
    recentContactActions?.result?.result ??
    [];
  const actionData = candidate?.contactActionsObjs ?? [];
  const lastactionData = actionData[actionData.length - 1];
  const isApplication = candidate?.candidateStatusTags?.includes('applied');

  const status = useMemo(() => {
    if (isApplication) {
      if (lastactionData?.actions && lastactionData?.actions?.length > 0) {
        return 'Mapped';
      } else if (isCvViewed) {
        return 'Viewed';
      } else {
        return 'New';
      }
    }
  }, [isApplication, isCvViewed, lastactionData?.actions]);

  const setData = () => sessionStorage.setItem('scrollPosition', window.scrollY.toString());
  const url = `/candidate-layout/${candidate.isJobCandidateMapping ? 'mappings' : 'profile'}?id=${
    isApplication ? candidate.candidateId : candidate.id
  }${
    isApplication ? `&interaction=${candidate.id}&array=${array}` : `&array=${array}`
  }&filterParms=${location.search}&q=${getEncodedQueryParams({
    query: encodeURI(searchQuery ?? ''),
  })}&backwardpathArray=${getEncodedQueryParams(JSON.stringify(backwardpathArray))}`;
  return (
    <>
      <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
        <Card>
          <Box px={2} py={1}>
            <Grid container item xs={12} alignItems="center">
              <Grid item xs={8}>
                <Box pl={1}>
                  <Grid container xs={12}>
                    <Stack direction="row">
                      <Checkbox
                        sx={{ p: 0 }}
                        onClick={(e) => {
                          checkboxAmplitudeEvent();

                          checkBoxOnclick && checkBoxOnclick(e);
                        }}
                        checked={isSelected}
                        size="small"
                        style={{ pointerEvents: 'auto' }}
                        disabled={!candidate.email || (candidate.isInDnc ?? false)}
                      />

                      <Grid container item xs={12} columnGap={0.5}>
                        <Box pt={0.4} px={0.5}>
                          <CircularImage src={candidate?.profileImage ?? ''} />
                        </Box>
                        <Box pt={0.8}>
                          <RouterLink to={url} style={{ textDecoration: 'none' }}>
                            <WsTypography
                              variant={WsTypoVariants.TITLE}
                              color={WsTypoColors.BLACK}
                              cursor="pointer"
                              onClick={() => {
                                setData();
                                amplitude(
                                  candidate.isJobCandidateMapping
                                    ? 'CandidateView_Redirect_Pipeline'
                                    : 'CandidateView_Redirect_Talentpool',
                                  {
                                    clickedOn: 'Redirect Submission',
                                    pageName: 'candidate-layout',
                                    pageUrl: window.location.href,
                                  }
                                );
                                //   onCVClick && candidateIndex != null && onCVClick(candidateIndex);
                              }}
                            >
                              {candidate.name ?? ''}
                            </WsTypography>
                            <PulseIconText
                              hover={
                                candidate.createdOn
                                  ? getDateUsingFormat(candidate.createdOn, 'D MMMM YYYY, HH:mm')
                                  : ''
                              }
                              text={`created  ${timeSince(String(candidate.createdOn))} by ${
                                candidate.createdBy
                              }`}
                            />
                          </RouterLink>
                        </Box>
                      </Grid>
                    </Stack>
                  </Grid>
                </Box>
              </Grid>
              {!candidate.isInDnc && (
                <Grid item xs={4} container justifyContent="flex-end">
                  {candidate.responseData &&
                    candidate.responseData.score > 1 &&
                    getCandidateScoreStatus(
                      Number(candidate.responseData?.score),
                      Number(candidate.responseData?.maxScore),
                      false
                    )}
                  {(candidate?.aiMatchScore ?? -1) >= 0 && (
                    <Box p={0.5}>
                      <WsBadge
                        label={`AI Match: ${candidate.aiMatchScore}%`}
                        badgeSize={WsBadgeSize.LARGE}
                        badgeType={
                          (candidate?.aiMatchScore ?? -1) >= 70
                            ? WsBadgetype.SPECIAL
                            : (candidate?.aiMatchScore ?? -1) >= 50
                            ? WsBadgetype.PENDING
                            : WsBadgetype.FAILED
                        }
                      />
                    </Box>
                  )}
                  {status && (
                    <Box mt={0.5}>
                      <WsChip
                        tooltipText="Application Status"
                        variant={WsChipVariants.PRIMARY}
                        isPointer={false}
                        value={status}
                      />
                    </Box>
                  )}
                  <Tooltip title="Share">
                    <IconButton
                      onClick={() => {
                        onOpenShareIcon && onOpenShareIcon(candidate);
                        firingAmplitudeEvents(
                          'Talentpool_candidate_share',
                          'Share',
                          workspace,
                          'Candidates'
                        );
                        if (amplitudeEventHandler) amplitudeEventHandler('Share');
                      }}
                    >
                      <BiShareAlt size={22} color={WsColors.TertiaryShades500} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Setup a Reminder" className="add-a-reminder">
                    <IconButton
                      size="medium"
                      onClick={() => {
                        firingAmplitudeEvents(
                          'Talentpool_candidate_Create_reminder',
                          'Setup a Reminder',
                          workspace,
                          'Candidates'
                        );
                        setOpen(!open);
                      }}
                    >
                      <TaskOutlinedIcon sx={{ color: WsColors.TertiaryShades500 }} />
                    </IconButton>
                  </Tooltip>
                  {/* <Tooltip title="Calendar">
                    <IconButton>
                      <FaRegCalendarAlt size={21} color={WsColors.TertiaryShades500} />
                    </IconButton>
                  </Tooltip> */}
                </Grid>
              )}
              <WsDialog openDialog={open}>
                <WsTaskCreationCard
                  source="Talentpool_candidate_Add_reminder"
                  closeDialog={() => setOpen(false)}
                  candidate={candidate}
                />
              </WsDialog>
            </Grid>
            {!candidate.isInDnc ? (
              <>
                {candidate.lastEmailAction && (
                  <Grid item xs={12}>
                    <PulseIconText
                      text={`${candidate.lastEmailAction?.createdBy} sent an email ${timeSince(
                        String(candidate.lastEmailAction?.createdByEmail)
                      )}`}
                    />
                  </Grid>
                )}
                <Grid direction="row" gap={2} flexWrap="wrap" item container py={0.5}>
                  {candidate.email && (
                    <CommunicationLinks
                      icon={<FiMail size={14} color={WsColors.TheBlues500} />}
                      emailOrPhNo={candidate.email}
                      objects={emailOptions}
                      onActionClick={openWidget}
                    />
                  )}
                  {removeDuplicates(candidate.alternateEmails, candidate.email).length > 0 && (
                    <>
                      {showMoreEmails ? (
                        <>
                          {removeDuplicates(candidate.alternateEmails, candidate.email).map(
                            (email, index) => (
                              <CommunicationLinks
                                key={index}
                                icon={<FiMail size={14} color={WsColors.TheBlues500} />}
                                emailOrPhNo={email}
                                objects={emailOptions}
                                onActionClick={openWidget}
                              />
                            )
                          )}
                        </>
                      ) : (
                        <SmallBoxWithRadius>
                          <Grid
                            item
                            container
                            xs={12}
                            alignItems="center"
                            columnGap={0.5}
                            sx={{ cursor: 'pointer' }}
                          >
                            <WsTypography
                              variant={WsTypoVariants.BODY1}
                              color={WsTypoColors.PRIMARY}
                              onClick={() => setShowMoreEmails(true)}
                              cursor="pointer"
                            >
                              {`+${
                                removeDuplicates(candidate.alternateEmails, candidate.email).length
                              } More`}
                            </WsTypography>
                          </Grid>
                        </SmallBoxWithRadius>
                      )}
                    </>
                  )}
                  {candidate.phoneNumber && (
                    <CommunicationLinks
                      icon={<MdOutlinePhone size={16} color={WsColors.TheBlues500} />}
                      emailOrPhNo={candidate.phoneNumber}
                      objects={phoneOptions}
                      onActionClick={openWidget}
                    />
                  )}
                  {removeDuplicatesPhNos(
                    candidate.alternatePhoneNumbers,
                    candidate.phoneNumber ?? ''
                  ).length > 0 && (
                    <>
                      {showMoreContact ? (
                        <>
                          {removeDuplicatesPhNos(
                            candidate.alternatePhoneNumbers,
                            candidate.phoneNumber ?? ''
                          ).map((phone, index) => (
                            <CommunicationLinks
                              key={index}
                              icon={<MdOutlinePhone size={16} color={WsColors.TheBlues500} />}
                              emailOrPhNo={parseInt(phone).toString()}
                              objects={phoneOptions}
                              onActionClick={openWidget}
                            />
                          ))}
                        </>
                      ) : (
                        <SmallBoxWithRadius>
                          <Grid
                            item
                            container
                            xs={12}
                            alignItems="center"
                            columnGap={0.5}
                            sx={{ cursor: 'pointer' }}
                          >
                            <WsTypography
                              variant={WsTypoVariants.BODY1}
                              color={WsTypoColors.PRIMARY}
                              onClick={() => setShowMoreContact(true)}
                              cursor="pointer"
                            >
                              {`+${
                                getAllAlternateNumbers(candidate.alternatePhoneNumbers).length
                              } More`}
                            </WsTypography>
                          </Grid>
                        </SmallBoxWithRadius>
                      )}
                    </>
                  )}
                </Grid>
                <Grid container item xs={12} pl={1} py={1} spacing={1}>
                  {getCandidateDetails(candidate, CandidateType.TALENTPOOL)?.map(
                    (detailsObj, index) => (
                      <Grid item xs={3} key={index}>
                        <WsIconText
                          icon={detailsObj.icon ?? <></>}
                          text={
                            detailsObj.popOverText === 'Current JobTitle' && searchQuery
                              ? highlightKeys(String(detailsObj.labelName), searchQuery ?? '')
                              : String(detailsObj.labelName)
                          }
                          opacity={true}
                          popOverText={`${detailsObj.popOverText}`}
                          textCursor="pointer"
                          isHtml={
                            detailsObj.popOverText === 'Current JobTitle' && !isEmpty(searchQuery)
                          }
                        />
                      </Grid>
                    )
                  )}
                </Grid>
                {!isEmpty(candidate.skills) && (
                  <Grid container item xs={12} pt={1} alignItems="center">
                    <Box pt={0.5} pr={0.6}>
                      <WsIconTag />
                    </Box>
                    <WsTypography
                      variant={WsTypoVariants.SUB_TITLE}
                      color={WsTypoColors.PRIMARY}
                      cursor="pointer"
                    >
                      Skills :
                    </WsTypography>
                    <WsTagsList
                      chipArray={candidate.skills}
                      count={10}
                      query={searchQuery ?? ''}
                      type={ChipsType.PRIMARY}
                      borderColorFlag={true}
                    />
                  </Grid>
                )}
                {!isEmpty(actionTags) && (
                  <Grid container item xs={12} pt={1}>
                    <Box pt={0.5} pr={0.6}>
                      <WsIconTag />
                    </Box>
                    <WsTypography
                      variant={WsTypoVariants.SUB_TITLE}
                      color={WsTypoColors.PRIMARY}
                      cursor="pointer"
                    >
                      Actions :
                    </WsTypography>
                    <Grid item xs={10}>
                      <WsTagsList
                        chipArray={actionTags}
                        count={8}
                        type={ChipsType.SECONDARY}
                        query={searchQuery ?? ''}
                      />
                    </Grid>
                  </Grid>
                )}
              </>
            ) : (
              <Grid container item xs={12} p={4}>
                {candidate.dncDetails && (
                  <Tooltip
                    title={
                      candidate.dncDetails?.deleteRequestAcceptedBy
                        ? getDateUsingFormat(
                            String(candidate.dncDetails?.acceptedOn),
                            'D MMMM YYYY, HH:mm'
                          )
                        : ''
                    }
                  >
                    <Typography
                      color={WsColors.Red400}
                      dangerouslySetInnerHTML={{
                        __html: getDncMessage(
                          candidate.dncDetails,
                          candidate.dncDetails?.isAddedByCandidate
                            ? candidate.name
                            : candidate.dncDetails?.modifiedBy ?? ''
                        ),
                      }}
                    ></Typography>
                  </Tooltip>
                )}
              </Grid>
            )}
          </Box>
          {interaction && !candidate.isInDnc && <CandidateStageStatus interaction={interaction} />}
          <Box sx={{ backgroundColor: WsColors.TheBlues25 }} p={1.5}>
            <Stack direction="row">
              <Grid item xs={6} pt={1}>
                {!candidate.isInDnc && (
                  <PulseIconText
                    hover={
                      candidate.modifiedOn
                        ? getDateUsingFormat(candidate.modifiedOn, 'D MMMM YYYY, HH:mm')
                        : ''
                    }
                    text={`Last update ${timeSince(String(candidate.modifiedOn))} by 
              ${candidate.modifiedBy}`}
                  />
                )}
                {!candidate.isInDnc && candidate.dateLastActiveOnJobBoard ? (
                  <PulseIconText
                    text={`Last Active ${timeSince(candidate.dateLastActiveOnJobBoard)} on ${
                      candidate?.sources && candidate?.sources[0]
                    }`}
                    hover={'Last Active On: ' + candidate.dateLastActiveOnJobBoard}
                  />
                ) : (
                  !candidate.isInDnc &&
                  candidate.dateResumeLastUpdatedOnJobBoard && (
                    <PulseIconText
                      text={`Resume Updated ${timeSince(
                        candidate.dateResumeLastUpdatedOnJobBoard
                      )} on ${candidate?.sources && candidate?.sources[0]}`}
                      hover={'Resume Updated On: ' + candidate.dateResumeLastUpdatedOnJobBoard}
                    />
                  )
                )}
              </Grid>
              <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
                <Grid item xs={6} container justifyContent="flex-end">
                  <Stack direction="row" spacing={2}>
                    {isApplication && isEmpty(actionTags) ? (
                      <></>
                    ) : (
                      !candidate.isInDnc && (
                        <WsButton
                          className="map-as-lead"
                          variant="outlined"
                          onClick={() => {
                            if (isMapCandidate) {
                              setOpenMapping(true);
                              amplitudeEventHandler && amplitudeEventHandler('Map as Lead');
                              firingAmplitudeEvents(
                                'Talentpool_candidate_Map_as_Lead',
                                'Map as Lead',
                                workspace,
                                'Candidates'
                              );
                            } else {
                              setNotification(warning(accessDeniedNotoficationTxt));
                            }
                          }}
                          size="large"
                        >
                          Map as Lead
                        </WsButton>
                      )
                    )}
                    {isApplication && isEmpty(actionTags) ? (
                      <></>
                    ) : (
                      !candidate.isInDnc && (
                        <WsButton
                          className="submit-candidate"
                          variant="outlined"
                          onClick={() => {
                            if (isSubmitCandidate) {
                              setOpenSubmitCandidate(true);
                            } else {
                              setNotification(warning(accessDeniedNotoficationTxt));
                            }
                          }}
                          size="large"
                        >
                          Submit
                        </WsButton>
                      )
                    )}
                  </Stack>
                </Grid>
              </ErrorBoundary>
            </Stack>
          </Box>
          <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
            {openMapping && (
              <MapAsLead
                showProfile={false}
                candidate={candidate}
                doAssignmentCheck={true}
                job={selectedJob ?? job}
                close={() => setOpenMapping(false)}
              />
            )}
          </ErrorBoundary>
          <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
            {openSubmitCandidate && (selectedJob || job) ? (
              <UpdateProfileNew
                candidate={candidate}
                openUpdatePanel={openSubmitCandidate}
                closeUpdatePanel={() => setOpenSubmitCandidate(false)}
                job={selectedJob ?? job}
                hideJobSelection={false}
                heading={'Submit Candidate'}
                isSubmit={true}
              />
            ) : (
              <WsDrawer
                open={openSubmitCandidate}
                style={{ zIndex: '1300' }}
                hideHeader={true}
                onClose={() => setOpenSubmitCandidate(false)}
                size="medium"
              >
                <JobSelection
                  getJob={(job) => {
                    updateSelectedJob(job);
                  }}
                  job={job}
                  onBackButton={() => setOpenSubmitCandidate(false)}
                />
              </WsDrawer>
            )}
          </ErrorBoundary>
        </Card>
        <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
          {openJobSelectionWidget.open && candidate?.id && (
            <ActionWidget
              onSelect={() =>
                setOpenJobSelectionWidget({ open: false, action: openJobSelectionWidget.action })
              }
              fromPage={'talentpool'}
              action={openJobSelectionWidget.action}
              candidateId={candidate?.id}
            />
          )}
        </ErrorBoundary>
      </ErrorBoundary>
    </>
  );
};

export default TalentPoolCandidateCard;
